import React from "react";
import "./index.scss";

export const LoadingSpinner = (props) => {
  return <div className={`spinning-loader ${props.useClass}`}></div>;
};
